/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Tooltip,
} from 'reactstrap';

import { get } from '../../helpers/api_helper';

function GrossRevenueWidget(props) {
  const {
    t, date, toggleDatePicker,
  } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [infotip, setInfotip] = useState(false);
  const [unitRevenue, setUnitRevenue] = useState(null);
  const tooltipId = `gross-revenue-tooltip-${props.mode}`;

  const formatCurrency = (amount, currency = 'USD') => (
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amount)
  );

  const formatPrettyDate = () => {
    const d = new Date(date);

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dayName = days[d.getDay()];
    const monthName = months[d.getMonth()];
    const dayOfMonth = d.getDate();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${dayName}, ${monthName} ${dayOfMonth}${getOrdinal(dayOfMonth)}`;
  };

  const nextUnitUp = () => {
    switch (props.mode) {
      case 'daily':
        return 'week';
      case 'weekly':
        return 'month';
      case 'monthly':
        return 'month';
      default:
        return 'day';
    }
  };

  const thisRevenue = () => {
    if (unitRevenue === null) return 0;
    switch (props.mode) {
      case 'daily':
        return unitRevenue.day_revenue;
      case 'monthly':
        return unitRevenue.month_revenue;
      case 'yearly':
        return unitRevenue.year_revenue;
      default:
        return 0;
    }
  };

  const previousRevenue = () => {
    if (unitRevenue === null) return 0;
    switch (props.mode) {
      case 'daily':
        return unitRevenue.prior_week_day_revenue;
      case 'monthly':
        return unitRevenue.prior_month_revenue;
      case 'yearly':
        return unitRevenue.prior_year_revenue;
      default:
        return 0;
    }
  };

  const currentRevenue = thisRevenue();
  const priorRevenue = previousRevenue();
  const changeAmount = currentRevenue - priorRevenue;
  const isUp = changeAmount >= 0;
  const percentChangeValue = priorRevenue > 0 ? ((changeAmount / priorRevenue) * 100) : 0;
  let valueToneClass = 'is-neutral';
  if (percentChangeValue > 0) {
    valueToneClass = 'is-up';
  } else if (percentChangeValue <= -2) {
    valueToneClass = 'is-down';
  }
  const percentageChange = priorRevenue > 0
    ? `${isUp ? '+' : ''}${percentChangeValue.toFixed(1)}%`
    : t('n/a');
  const eightWeekAverageRevenue = Number(unitRevenue?.eight_week_average_day_revenue ?? 0);
  const averagePercentChange = eightWeekAverageRevenue > 0
    ? ((currentRevenue - eightWeekAverageRevenue) / eightWeekAverageRevenue) * 100
    : null;
  let averageComparisonDirection = 'even';
  if (averagePercentChange > 0) {
    averageComparisonDirection = 'up';
  } else if (averagePercentChange < 0) {
    averageComparisonDirection = 'down';
  }
  const averageComparisonIcon = {
    up: 'mdi-trending-up',
    down: 'mdi-trending-down',
    even: 'mdi-trending-neutral',
  }[averageComparisonDirection];
  const averageComparisonText = averagePercentChange === null
    ? t('n/a')
    : `${Math.abs(averagePercentChange).toFixed(1)}% ${t(averageComparisonDirection)}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.mode !== 'daily') {
          const response = await get(`/api/sales/reports/revenue/monthly?isoDay=${date}`);
          setUnitRevenue(response);
        } else {
          const response = await get(`/api/sales/reports/revenue/gross?isoDay=${date}`);
          setUnitRevenue(response);
        }
      } catch (error) {
        toastr.error(t('Error fetching gross revenue data'));
      }
    };

    fetchData();
  }, [date]);

  return (
    <div>
      {unitRevenue !== null ? (
        <div className="dashboard-revenue-card">
          <div className="dashboard-revenue-card__body">
            <div className="dashboard-revenue-card__top">
              <div>
                <span className="dashboard-revenue-card__eyebrow">
                  {props.mode === 'monthly' ? t('Monthly revenue') : t('Daily revenue')}
                </span>
                {!props.overrideTitle && (
                <h5 className="dashboard-revenue-card__title">
                  {t(`Gross Revenue for ${formatPrettyDate()}`)}
                  <button
                    type="button"
                    className="dashboard-icon-button"
                    id={tooltipId}
                  >
                    <span className="mdi mdi-information-outline" />
                  </button>
                  <Tooltip
                    placement="bottom"
                    isOpen={infotip}
                    target={tooltipId}
                    toggle={() => {
                      setInfotip(!infotip);
                    }}
                  >
                    {t('Discludes taxes, and shipping. Includes discounts.')}
                  </Tooltip>
                  <button type="button" className="dashboard-icon-button" onClick={toggleDatePicker}>
                    <span className="mdi mdi-calendar" />
                  </button>
                </h5>
                )}
                {props.overrideTitle && (
                <h5 className="dashboard-revenue-card__title">
                  {props.overrideTitle}
                </h5>
                )}
              </div>

              <div className={`dashboard-revenue-card__change ${isUp ? 'is-up' : 'is-down'}`}>
                <span className={`mdi ${isUp ? 'mdi-trending-up' : 'mdi-trending-down'} fs-4`} />
                <span className="dashboard-revenue-card__delta">
                  {formatCurrency(changeAmount)}
                  {' '}
                  <span>{percentageChange}</span>
                  <span className="dashboard-revenue-card__change-label">
                    {t(`vs same time last ${nextUnitUp()}`)}
                  </span>
                </span>
              </div>
            </div>

            <h2 className={`dashboard-revenue-card__value ${valueToneClass}`}>
              {formatCurrency(currentRevenue)}
            </h2>

            <div className="dashboard-revenue-card__meta">
              <div className="dashboard-revenue-card__stat">
                <span className="dashboard-revenue-card__stat-label">{t(`Same time last ${nextUnitUp()}`)}</span>
                <span className="dashboard-revenue-card__stat-value">{formatCurrency(priorRevenue)}</span>
              </div>
              {props.mode === 'daily' ? (
                <div className="dashboard-revenue-card__stat">
                  <span className="dashboard-revenue-card__stat-label">
                    {unitRevenue.is_today
                      ? t('8-week average at this time')
                      : t('8-week daily average')}
                  </span>
                  <span className="dashboard-revenue-card__stat-value">
                    {formatCurrency(eightWeekAverageRevenue)}
                  </span>
                  <span className={`dashboard-revenue-card__stat-comparison is-${averageComparisonDirection}`}>
                    <span className={`mdi ${averageComparisonIcon}`} aria-hidden="true" />
                    {averageComparisonText}
                  </span>
                </div>
              ) : (
                <div className="dashboard-revenue-card__stat">
                  <span className="dashboard-revenue-card__stat-label">{t('Tracking period')}</span>
                  <span className="dashboard-revenue-card__stat-value">{t('Month to date')}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="p-3 text-center">
          <span className="mdi mdi-loading mdi-spin fs-2" />
        </div>
      )}
    </div>
  );
}

GrossRevenueWidget.defaultProps = {
  toggleDatePicker: () => {},
  mode: 'daily',
  overrideTitle: null,
};

GrossRevenueWidget.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  date: PropTypes.string.isRequired,
  mode: PropTypes.string,
  overrideTitle: PropTypes.string,
  toggleDatePicker: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(GrossRevenueWidget));
